import { render, staticRenderFns } from "./idinfo.vue?vue&type=template&id=0f749eec"
import script from "./idinfo.vue?vue&type=script&lang=js"
export * from "./idinfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports